if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');
      this.predictiveSearchResources =
        this.predictiveSearchResults.getAttribute('data-resources-types') ||
        'product';
      this.predictiveSearchMaxSize =
        this.predictiveSearchResults.getAttribute('data-max-results') || 4;
      this.buttonReset = this.querySelector('[data-search-reset]');
      this.loader = this.querySelector('[data-loader]');
      this.ww = window.innerWidth;

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 500).bind(this),
      );

      this.buttonReset?.addEventListener('click', () => {
        this.close();
        this.input.focus();
        this.buttonReset.classList.add('hidden');
      });

      // remove the 'show filters' class from the body when we go from large to small screen
      this.debouncedOnResize = debounce(() => {
        const windowWidth = window.innerWidth;

        // check if there's an actual change in window width, because the resize is triggered on mobile when the viewport changes with the header
        if (windowWidth === this.ww) return;
        this.ww = windowWidth;

        if (this.ww >= 1024) {
          this.close();
        }
      }, 100);
      window.addEventListener('resize', this.debouncedOnResize.bind(this));
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (searchTerm.length > 1) {
        this.buttonReset?.classList.remove('hidden');
      }
      if (searchTerm.length < 3) {
        this.close(false);
        return;
      }
      this.loader.classList.remove('hidden');
      this.getSearchResults(searchTerm);
    }

    /**
     * getSearchResults
     * @param {String} searchTerm
     * @description https://shopify.dev/api/ajax/reference/predictive-search
     */
    getSearchResults(searchTerm) {
      const args = [
        `q=${searchTerm}`,
        `resources[type]=${this.predictiveSearchResources}`,
        `resources[limit]=${this.predictiveSearchMaxSize}`,
        'resources[options][fields]=title,variants.sku',
        'section_id=predictive-search',
      ].join('&');

      fetch(`${routes.predictive_search_url}?${args}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);

            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        })
        .finally(() => {
          this.loader.classList.add('hidden');
          if (window.apps.reviewsIo) getRating();
        });
    }

    open() {
      trapFocus(this);
      // add the search class to the body so the shadow displays
      if (window.innerWidth >= 1024) {
        document.body.classList.add('header-search-is-open');
      } else {
        this.predictiveSearchResults.style.display = 'block';
      }
      showModal(document.getElementById('SearchModal'));
    }

    close(clearInput = true) {
      if (!document.body.classList.contains('header-search-is-open')) return;
      clearInput && this.input.value === '';

      removeTrapFocus();
      // add the search class to the body so the shadow displays
      if (window.innerWidth >= 1024) {
        document.body.classList.remove('header-search-is-open');
      } else {
        this.predictiveSearchResults.innerHTML == '';
        this.predictiveSearchResults.style.display = 'none';
      }
      hideModal(document.getElementById('SearchModal'));
    }
  }

  window.PredictiveSearch = PredictiveSearch;

  customElements.define('predictive-search', PredictiveSearch);
}
